var _desc, _style, _circle, _ellipse, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySelectCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-select-company-title"
  }, "Valitse yritys ja asiointirooli") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-select-company-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-select-company-desc"
  }, "Toimistorakennus naapurirakennusten keskell\xE4")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-select-company-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-select-company-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-select-company-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-select-company-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-select-company-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-select-company-lfill  { fill: var(--empty-line, #c7d2fe); }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 86,
    className: "empty-select-company-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 164,
    rx: 66,
    ry: 6,
    className: "empty-select-company-accent",
    opacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 82,
    width: 34,
    height: 76,
    rx: 4,
    className: "empty-select-company-lfill",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 66,
    width: 36,
    height: 92,
    rx: 4,
    className: "empty-select-company-lfill",
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 92 h6 M68 92 h6 M56 104 h6 M68 104 h6 M56 116 h6 M68 116 h6 M56 128 h6 M68 128 h6            M166 76 h6 M178 76 h6 M166 88 h6 M178 88 h6 M166 100 h6 M178 100 h6 M166 112 h6 M178 112 h6 M166 124 h6 M178 124 h6",
    stroke: "var(--empty-surface, #ffffff)",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 40,
    width: 84,
    height: 118,
    rx: 5,
    className: "empty-select-company-surface empty-select-company-stroke",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 40,
    width: 84,
    height: 6,
    className: "empty-select-company-accent",
    opacity: 0.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.45,
    x: 87,
    y: 56,
    width: 12,
    height: 10,
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 105,
    y: 56,
    width: 12,
    height: 10,
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 123,
    y: 56,
    width: 12,
    height: 10,
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.45,
    x: 141,
    y: 56,
    width: 12,
    height: 10,
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 87,
    y: 74,
    width: 12,
    height: 10,
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.45,
    x: 105,
    y: 74,
    width: 12,
    height: 10,
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 123,
    y: 74,
    width: 12,
    height: 10,
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 141,
    y: 74,
    width: 12,
    height: 10,
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 87,
    y: 92,
    width: 12,
    height: 10,
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 105,
    y: 92,
    width: 12,
    height: 10,
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.45,
    x: 123,
    y: 92,
    width: 12,
    height: 10,
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 141,
    y: 92,
    width: 12,
    height: 10,
    rx: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 87,
    y: 110,
    width: 12,
    height: 10,
    rx: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-select-company-accent",
    opacity: 0.2,
    x: 141,
    y: 110,
    width: 12,
    height: 10,
    rx: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 114,
    width: 40,
    height: 6,
    rx: 2,
    className: "empty-select-company-accent",
    opacity: 0.55
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 120,
    width: 28,
    height: 38,
    rx: 2,
    className: "empty-select-company-accent",
    opacity: 0.18
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 120,
    x2: 120,
    y2: 158,
    className: "empty-select-company-stroke",
    strokeWidth: 1.6,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 138,
    x2: 116,
    y2: 142,
    className: "empty-select-company-stroke",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 138,
    x2: 124,
    y2: 142,
    className: "empty-select-company-stroke",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 158,
    x2: 194,
    y2: 158,
    className: "empty-select-company-line",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySelectCompany);
export default __webpack_public_path__ + "static/media/empty-select-company.482cddf02ead1427dadf01dbc88bd7e6.svg";
export { ForwardRef as ReactComponent };